/*models/axes/index*/
function _(require, module, exports) {
    var axis_1 = require(72    /* ./axis */);
    exports.Axis = axis_1.Axis;
    var categorical_axis_1 = require(73    /* ./categorical_axis */);
    exports.CategoricalAxis = categorical_axis_1.CategoricalAxis;
    var continuous_axis_1 = require(74    /* ./continuous_axis */);
    exports.ContinuousAxis = continuous_axis_1.ContinuousAxis;
    var datetime_axis_1 = require(75    /* ./datetime_axis */);
    exports.DatetimeAxis = datetime_axis_1.DatetimeAxis;
    var linear_axis_1 = require(77    /* ./linear_axis */);
    exports.LinearAxis = linear_axis_1.LinearAxis;
    var log_axis_1 = require(78    /* ./log_axis */);
    exports.LogAxis = log_axis_1.LogAxis;
    var mercator_axis_1 = require(79    /* ./mercator_axis */);
    exports.MercatorAxis = mercator_axis_1.MercatorAxis;    
}